{
  "fr": {
    "number": {
      "format": {
        "precision": 2,
        "strip_insignificant_zeros": true,
        "delimiter": ".",
        "separator": ","
      },
      "units": {
        "au": "AU",
        "uec": "aUEC",
        "currency": "$",
        "uecPerUnit": "aUEC / Unit",
        "distance": "m",
        "weight": "t",
        "speed": "m/s",
        "cargo": "SCU",
        "person": "personne",
        "people": {
          "one": "personne",
          "other": "personnes"
        }
      },
      "uec": "%{count} <span class=\"text-muted\">aUEC</span>",
      "uecPerUnit": "%{count} <span class=\"text-muted\">aUEC/unit</span>",
      "percent": "%{count} %",
      "distance": "%{count} m",
      "newton": "%{count} KN",
      "thrust": "%{count} KN",
      "weight": "%{count} t",
      "speed": "%{count} m/s",
      "acceleration": "%{count} m/s²",
      "seconds": "%{count} s",
      "rateOfFire": "%{count} shots/min",
      "rotation": "%{count} deg/s",
      "degrees": "%{count}°",
      "cargo": "%{count} SCU",
      "integer": "%{count}",
      "dps": "%{count} DPS",
      "damage": "%{count} DMG",
      "shieldHp": "%{count} HP",
      "shieldRegen": "%{count}s Regen",
      "coolingRate": "%{count} Refroidissement",
      "powerOutput": "%{count} Puissance",
      "powerPips": "%{count} Pips",
      "driveSpeed": "%{count} km/s",
      "weaponRange": "%{count} m",
      "weaponSpeed": "%{count} m/s",
      "missileRange": "%{count} m",
      "missileSpeed": "%{count} m/s",
      "lockTime": "%{count}s",
      "regenTime": "%{count}s",
      "delayTime": "%{count}s",
      "spoolTime": "%{count}s",
      "cooldownTime": "%{count}s",
      "fuelRate": "%{count}",
      "aimAssistRange": "%{count} m",
      "fuel": "%{count}",
      "ships": {
        "one": "%{count} vaisseau",
        "other": "%{count} vaisseaux"
      },
      "people": {
        "one": "%{count} personne",
        "other": "%{count} personnes"
      },
      "rem": "%{count} REM",
      "remPerSecond": "%{count} REM/s",
      "microScu": "%{count} µSCU"
    }
  }
}
